import { url } from '@zz-yp/hunter-js-utils'
const urlInfoId = url.getParam('infoId')
class Zpm {
  constructor(vue) {
    this.vue = vue
  }

  install() {
    this.vue.directive('zpm', {
      // 当被绑定的元素插入到 DOM 中时执行
      bind(el, binding) {
        const {
          infoid = '',
          sectionid = '',
          sortname = '',
          sortid = '',
          url = '',
          other = '',
          areaexposure = '',
          isdot = '',
          metric = '',
          info = '',
          backup = '',
          goodsexposure = ''
        } = binding.value
        const zpmAttrs = {
          'zz-infoid': infoid || urlInfoId,
          'zz-sectionid': sectionid,
          'zz-sortid': sortid,
          'zz-sortname': sortname,
          'zz-url': url,
          'zz-other': other,
          'data-areaexposure': areaexposure,
          'lego-goods-exposure': goodsexposure,
          'data-isdot': isdot,
          'data-metric': metric,
          'data-info': info,
          'zz-backup': JSON.stringify(backup)
        }
        //   setAttributes(el, zpm_attrs)
        Object.keys(zpmAttrs).forEach((key) => {
          if (zpmAttrs[key]) {
            el.setAttribute(key, zpmAttrs[key])
          }
        })
      }
    })
  }
}

export default Zpm
